import { render, staticRenderFns } from "./AssignmentStatusSelect.vue?vue&type=template&id=a91d8b36&scoped=true"
import script from "./AssignmentStatusSelect.vue?vue&type=script&lang=js"
export * from "./AssignmentStatusSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91d8b36",
  null
  
)

export default component.exports